import { useEffect, useRef, useState } from 'react';
import { cn } from '@/lib/core/utils/cn';

interface ProgressLoadingProps {
  durationMs?: number;
  className?: string;
  onComplete?: () => void;
}

export function ProgressLoading({ durationMs = 3000, className, onComplete }: ProgressLoadingProps) {
  const [progress, setProgress] = useState(0);
  const firedRef = useRef(false);

  useEffect(() => {
    const stepMs = durationMs / 100;
    const id = setInterval(() => {
      setProgress(p => {
        if (p >= 100) {
          clearInterval(id);
          return 100;
        }
        return p + 1;
      });
    }, stepMs);
    return () => clearInterval(id);
  }, [durationMs]);

  useEffect(() => {
    if (progress === 100 && !firedRef.current) {
      firedRef.current = true;
      onComplete?.();
    }
  }, [progress, onComplete]);

  return (
    <p
      aria-live="polite"
      aria-label={`Loading ${progress}%`}
      className={cn(
        'font-pp-neue-montreal text-[12px] leading-3.5 font-[350] tracking-[0.5px] uppercase',
        className
      )}
    >
      {progress}%
    </p>
  );
}
